module.exports = __webpack_public_path__ + "static/media/Rectangleinactive.b0f36911.svg";